import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postGenerateSchedule = async (body) => {
  const { data } = await SigliveServiceV1({ method: 'POST', url: `/schedule/submit-generated-schedule`, data: body });

  return data?.data;
};

export default postGenerateSchedule;
